<template lang="pug">
md-layout(md-column='')
  // Create domain
  router-link(:to='{ name: "CreateDomainList" }')
    md-button#btn-add-domain.md-fab.md-fab-bottom-right.md-icon-button(md-theme='blue')
      md-icon(md-iconset="fa fa-plus")

  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Domain Lists', :nav='nav')
    // Distributions List
    domain-table#domains
</template>

<script>
  import domainTable from '../../shared-components/domain/DomainTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    name: 'DomainList',
    components: {
      domainTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Domain Lists' }
        ]
      },
    }

  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -7px;
    margin-right: 5px;
  }
  #domains {
    margin: 15px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/domain/DomainList.vue